export const API_MAIN_ROOT: string | undefined = process.env.REACT_APP_BACKEND_ENDPOINT;
export const login: string = "/";
export const login_page: string = "/";
export const unauthorized_route: string = "/unauthorized-access";
export const support_page: string = "/support";
export const account_already_exists: string = "/account-already-exists";
export const registration_type: string = "/registration-type";
export const rcic_registration: string = "/rcic/registration";
export const rcic_profile: string = "/rcic/profile";
export const subscriber_registration: string = "/client/registration";
export const subscriber_registration_second_step: string = "/client/registration-second-step";
export const rcic_registration_second_step: string = "/rcic/registration-second-step";
export const rcic_search: string = "/client/consultant-search";
export const anonymous_rcic_search: string = "/rcic-search";
export const rcic_consultation_booking: string = "/rcic/profile";
export const book_consultation: string = "/client/book-consultation";
export const rcic_consultation_list: string = "/rcic/consultations";
export const rcic_my_clients: string = "/rcic/my-clients";
export const rcic_consultation_request_details: string = "/rcic/consultation-request";
export const consultation_workspace: string = "/rcic/consultations/:bookingId/workspace";
export const create_case_review: string = "/rcic/consultations/:bookingId/create-case";
export const service_agreement_review: string = "/rcic/consultations/:bookingId/service-agreement";
export const subscriber_profile_page: string = "/client/profile";
export const rcic_profile_update: string = "/rcic/profile/update";
export const client_profile_update: string = "/client/profile/edit";
export const subscriber_consultation_booking_requested_list: string = "/client/slot-booking-list";
export const subscriber_document_sign: string = "/client/initial-agreement-sign";
export const subscriber_retainer_document_sign: string = "/client/retainer-agreement-sign";
export const admin_initial_doc: string = "/admin/initial-doc";
export const admin_retainer_doc: string = "/admin/retainer-doc";
export const legal_correspondences: string = "/rcic/legal-correspondences";
export const rcic_initial_doc: string = legal_correspondences + "/rcic/initial-doc";
export const rcic_retainer_doc: string = legal_correspondences + "/rcic/retainer-doc";
export const rcic_agreement_templates: string = legal_correspondences + "/templates";
export const rcic_consultation_approval: string = "/rcic/consultation-slot-booking-approval";
export const rcic_retainer_doc_send: string = "/rcic/consultation-retainer-doc-send";
export const rcic_business_setup: string = "/rcic/business-setup";
export const verify_email: string = "/verify-email";
export const verify_email_message: string = "/verify-email-message";
export const resend_activation: string = "/resend-activation";
export const appointment_slot_meeting: string = "/appointment-slot-meeting";
export const appointment_slot_meeting_view: string = "/appointment-slot-meeting-view";
export const appointment_slot_meeting_reschedule: string = "/appointment-slot-meeting-reschedule";
export const appointment_slot_setup: string = "/rcic/schedule-setup";

export const case_management_rcic: string = "/rcic/case-management";
export const rcic_case_list: string = case_management_rcic + "/list";
export const meeting_notes: string = case_management_rcic + "/meeting-notes";
export const case_management_rcic_stream_documents: string = case_management_rcic + "/applicant-document-setup";
export const case_management_rcic_doc_view: string = case_management_rcic + "/applicant-document";
export const case_management_rcic_applicant_form: string = case_management_rcic + "/applicant";
export const legal_service_fees: string = case_management_rcic + "/legal-service-fees";
export const ircc_fees: string = case_management_rcic + "/ircc-fees";
export const third_party_fees: string = case_management_rcic + "/third-party-fees";

export const case_management_client: string = "/client/case-management";
export const case_management_client_document_submit: string = case_management_client + "/document-submit";
export const case_management_client_doc_view: string = case_management_client + "/applicant-document";
export const legal_service_fees_client: string = case_management_client + "/legal-service-fees";
export const third_party_fees_client: string = case_management_client + "/third-party-fees";

export const document_setup_entry: string = "/document-setup-entry";
export const document_setup_view: string = "/document-setup-view";
export const document_setup_list: string = "/document-setup";
export const document_setup_edit: string = "/document-setup-edit";
export const applicant_type_setup_list: string = "/applicant-type-setup";
export const applicant_type_setup_entry: string = "/applicant-type-setup-entry";
export const applicant_type_setup_edit: string = "/applicant-type-setup-edit";
export const applicant_type_setup_view: string = "/applicant-type-setup-view";
export const stream_type_setup_entry: string = "/stream-type-setup-entry";
export const stream_type_setup_view: string = "/stream-type-setup-view";
export const stream_type_setup_list: string = "/stream-type-setup";
export const stream_type_setup_edit: string = "/stream-type-setup-edit";
export const stream_documents_entry: string = "/stream-documents-entry";
export const stream_documents_view: string = "/stream-documents-view";
export const stream_documents_list: string = "/stream-documents";
export const stream_documents_edit: string = "/stream-documents-edit";
export const fee_setup_view: string = "/fee-setup-view";
export const fee_setup_entry: string = "/fee-setup-new";
export const fee_setup_list: string = "/fee-setup";
export const fee_setup_edit: string = "/fee-setup-edit";
export const pin_reset: string = "/rcic/reset-pin";
export const password_reset: string = "/reset-password";
export const forgot_password: string = "/forgot-password";
export const forgot_signup_method: string = "/forgot-signup-method";
export const submission_letter_generate: string = case_management_rcic + "/submission-letter-generate";
export const submission_letter_generate_edit: string = case_management_rcic + "/submission-letter-generate-edit";
export const payment_success: string = "/payment-success";
export const payment_cancel: string = "/payment-cancel";
export const service_payment_checkout_page: string = "/service-checkout-page";
export const legal_fee_payment_checkout_page: string = "/legal-fee-checkout-page";
export const third_party_fee_payment_checkout_page: string = "/third-party-fee-checkout-page";
export const mock_bkash_checkout: string = "/mock-bkash";
export const rcic_wallet: string = "/rcic/wallet";
export const rcic_wallet_commission_invoices: string = rcic_wallet + "?tab=invoices";
export const rcic_payout_accounts: string = rcic_wallet + "/payout-accounts";
export const wallet_transactions: string = rcic_wallet + "/transactions";
export const rcic_withdrawal_list: string = rcic_wallet + "/withdrawal";
export const rcic_withdrawal_details: string = rcic_withdrawal_list + "/details";
export const rcic_withdrawal_request: string = rcic_withdrawal_list + "/request";
export const rcic_wallet_withdrawals: string = rcic_wallet + "/local-withdrawals";
export const withdrawal_request_list: string = "/admin/withdrawal-request";
export const withdrawal_approval_page: string = withdrawal_request_list + "/approval";
export const admin_rcic_wallet_withdrawals: string = "/admin/rcic-wallet-withdrawals";

/** Account suspended page — accessible to suspended RCICs so they can navigate to billing. */
export const rcic_account_suspended: string = "/rcic/account-suspended";

export const admin_dashboard: string = "/admin/dashboard";
export const admin_rcic_officers: string = "/admin/rcic-officers";
export const admin_rcic_officers_details: string = admin_rcic_officers + "/details";
export const admin_clients: string = "/admin/clients";
export const admin_clients_details: string = admin_clients + "/details";
export const admin_service_purchases: string = "/admin/transaction/list";
export const admin_service_purchases_details: string = "/admin/transaction";
export const admin_platform_revenue: string = "/admin/transaction/platform-revenue";
export const admin_commission_invoices: string = "/admin/transaction/commission-invoices";
export const admin_third_party_fees: string = "/admin/third-party-fees";
export const notification_list: string = "/notification-list";
export const settings_page_rcic: string = "/rcic/settings";
export const settings_page_client: string = "/client/settings";
export const admin_settings: string = "/admin/settings";
export const pin_setup: string = "/rcic/pin-setup";
export const messages: string = "/messages";

// Expert Answers — Public
export const expert_answers: string = "/qa";
export const expert_answers_ask: string = expert_answers + "/ask";
export const expert_answers_my: string = expert_answers + "/my";
export const expert_answers_community: string = expert_answers + "/community";
export const expert_answers_community_ask: string = expert_answers_community + "/ask";
export const expert_answers_question_detail: string = expert_answers + "/questions/:id";
export const expert_answers_question_edit: string = expert_answers + "/questions/:id/edit";

// My Questions — Subscriber
export const my_questions: string = "/myqa";
export const my_questions_detail: string = my_questions + "/questions/:id";

// My Answers — RCIC
export const my_answers: string = "/myans";
export const my_answers_detail: string = my_answers + "/questions/:id";

// RCIC Community
export const community: string = "/community";
export const community_detail: string = community + "/questions/:id";

// MFA Setup
export const mfa_setup: string = "/mfa-setup";
export const mfa_setup_callback: string = "/mfa-setup-callback";
export const mfa_code: string = "/mfa-code";

// Reviews
export const client_my_reviews: string = "/client/my-reviews";
export const rcic_my_reviews: string = "/rcic/my-reviews";
export const admin_review_management: string = "/admin/review-management";

// Client Payments
export const client_payments: string = "/client/payments";
export const client_payments_details: string = client_payments + "/details";

// Reschedule Requests
export const client_reschedule_request: string = "/consultation/reschedule-request";
export const rcic_reschedule_requests: string = "/rcic/reschedule-requests";
export const rcic_action_centre: string = "/rcic/action-centre";
export const rcic_ai_practice_assistant: string = "/rcic/ai-practice-assistant";
export const rcic_plans_pricing: string = "/rcic/plans-pricing";
export const rcic_global_pricing: string = "/rcic/global-pricing";
export const pro_subscription_success: string = "/payment-success/pro-subscription";

// Refund Requests
export const client_refund_request: string = "/client/refund-request";
export const rcic_refund_queue: string = "/rcic/refund-requests";
export const rcic_initiate_refund: string = "/rcic/refund-initiate";
export const consultation_workspace_path = (bookingId: number | string) => `/rcic/consultations/${bookingId}/workspace`;
export const create_case_review_path = (bookingId: number | string) => `/rcic/consultations/${bookingId}/create-case`;
export const service_agreement_review_path = (bookingId: number | string) => `/rcic/consultations/${bookingId}/service-agreement`;

export const consultation_report: string = "/rcic/consultation-report/:workspaceId";
export const consultation_report_path = (workspaceId: number | string) => `/rcic/consultation-report/${workspaceId}`;

export const client_consultation_report: string = "/client/consultation-report/:bookingId";
export const client_consultation_report_path = (bookingId: number | string) => `/client/consultation-report/${bookingId}`;

export const admin_refund_queue: string = "/admin/refund-requests";
export const admin_refund_details: string = "/admin/refund-requests/details";

// Client Account Payment
export const client_account_payment_wizard: string = "/client-account-payment-wizard";
export const admin_client_account_payment: string = "/admin/client-account-payment";
export const admin_client_account_payment_details: string = admin_client_account_payment + "/details";

// Practice Continuity (PUA)
export const practice_continuity: string = "/rcic/practice-continuity";
export const practice_continuity_my_requests: string = practice_continuity + "/my-requests";
export const practice_continuity_incoming: string = practice_continuity + "/incoming";
export const practice_continuity_new: string = practice_continuity + "/new";
export const practice_continuity_detail: string = practice_continuity + "/:id";
export const practice_continuity_detail_path = (id: number | string) => `${practice_continuity}/${id}`;
export const practice_continuity_handover: string = practice_continuity + "/:id/handover";
export const practice_continuity_handover_path = (id: number | string) => `${practice_continuity}/${id}/handover`;
export const practice_continuity_settlement: string = practice_continuity + "/:id/settlement";
export const practice_continuity_settlement_path = (id: number | string) => `${practice_continuity}/${id}/settlement`;
export const practice_continuity_handover_review_path = (id: number | string) => `${practice_continuity}/${id}/handover-review`;
